export function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__col footer__col--brand">
          <span className="footer__logo">mycv.now</span>
          <span className="footer__tag">Track who's reading your resume.</span>
          <div className="footer__brand-meta">
            A <a href="https://cosmostoch.com" target="_blank" rel="noreferrer noopener" className="footer__company-inline">Cosmostoch Ventures LLP</a> product
          </div>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Product</h4>
          <a href="/" className="footer__link">Upload a resume</a>
          <a href="/analytics" className="footer__link">Analytics</a>
          <a href="/privacy" className="footer__link">Privacy</a>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Company</h4>
          <a href="https://cosmostoch.com" target="_blank" rel="noreferrer noopener" className="footer__link">cosmostoch.com ↗</a>
          <a href="mailto:krishna@cosmostoch.com" className="footer__link">krishna@cosmostoch.com</a>
        </div>

        <div className="footer__col footer__col--credit">
          <h4 className="footer__heading">Made by</h4>
          <div className="footer__by">Appili Vamsi Krishna</div>
          <a href="https://contact.appili.dev/#get-in-touch" target="_blank" rel="noreferrer noopener" className="footer__link">contact.appili.dev ↗</a>
        </div>
      </div>

      <div className="footer__bottom">
        <span>© {new Date().getFullYear()} Cosmostoch Ventures LLP. All rights reserved.</span>
        <span className="footer__bottom-links">
          <a href="/privacy" className="footer__bottom-link">Privacy</a>
        </span>
      </div>
    </footer>
  );
}
